import request from '@/api/request'
export default {
    loginByCode(params) {
        return request({
            url: '/login/user/phone',
            method: 'post',
            params: params
        })
    },

    // ========== 系统参数管理 ==========
    // 获取系统参数
    getSystemParams() {
        return request({
            url: '/system/get',
            method: 'get'
        })
    },

    // 更新系统参数
    updateSystemParams(data) {
        return request({
            url: '/system/update',
            method: 'post',
            data
        })
    },

    // 上传客户端APP安装包（文件可能较大，增加超时时间）
    uploadApp(data) {
        return request({
            url: '/system/uploadApp',
            method: 'post',
            data,
            timeout: 30000 // 5 分钟，避免上传被默认 5 秒超时中断
            // 不手动设置 Content-Type，让 axios 自动处理 multipart/form-data 和 boundary
        })
    },

    // ========== 用户使用记录管理 ==========
    // 分页查询使用记录
    getUsageLogList(params) {
        return request({
            url: '/usageLog/list',
            method: 'get',
            params
        })
    },

    // 获取用户使用统计
    getUsageLogStatistics(params) {
        return request({
            url: '/usageLog/statistics',
            method: 'get',
            params
        })
    },

    // ========== 语言响应格式配置管理 ==========
    // 获取所有语言响应格式配置
    getAllLanguageResponseFormats() {
        return request({
            url: '/systemPrompt/getAll',
            method: 'get'
        })
    },

    // 添加语言响应格式配置
    addLanguageResponseFormat(data) {
        return request({
            url: '/systemPrompt/add',
            method: 'post',
            data
        })
    },

    // 修改语言响应格式配置
    updateLanguageResponseFormat(data) {
        return request({
            url: '/systemPrompt/update',
            method: 'post',
            data
        })
    },

    // ========== Qwen 配置管理 ==========
    // 获取Qwen配置列表
    getConfigs() {
        return request({
            url: '/system/getConfigs',
            method: 'get'
        })
    },

    // 更新Qwen配置
    updateConfigs(data) {
        return request({
            url: '/system/updateConfigs',
            method: 'post',
            data
        })
    },

    // 单独更新单个Qwen配置
    updateConfig(data) {
        return request({
            url: '/system/updateConfig',
            method: 'post',
            data
        })
    }
}
